import Seo, { orgJsonLd } from "@/lib/Seo";
import Hero from "@/sections/Hero";
import Approach from "@/sections/Approach";
import ImpactPaths from "@/sections/ImpactPaths";
import Achievements from "@/sections/Achievements";
import ImpactStory from "@/sections/ImpactStory";
import KnowledgePreview from "@/sections/KnowledgePreview";
import UpcomingProducts from "@/sections/UpcomingProducts";
import Partners from "@/sections/Partners";
import FinalCTA from "@/sections/FinalCTA";
import Marquee from "@/components/Marquee";

export default function Home() {
  return (
    <>
      <Seo path="/" description="سياق — نفهم احتياج منظمتك، نحلّل سياقها، ثم نصمّم الحل الذي يقودها نحو أثر مجتمعي مستدام." jsonLd={orgJsonLd} />
      <Hero />
      <Approach />
      <ImpactPaths />
      <Marquee />
      <Achievements />
      <ImpactStory />
      <KnowledgePreview />
      <UpcomingProducts />
      <Partners />
      <FinalCTA />
    </>
  );
}
